(function () {
  const STORAGE_KEY = 'adiosAgeVerified';
  const MIN_AGE = 21;

  function openModal(modal) {
    modal.hidden = false;
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('age-modal-open');
  }

  function closeModal(modal) {
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('age-modal-open');
  }

  function isVerified() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    }
  }

  function setVerified() {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }
  }

  function calculateAge(year, month, day) {
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('age-verification-modal');
    const form = document.getElementById('age-verification-form');

    if (!modal || !form) return;

    if (!isVerified()) {
      openModal(modal);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const month = parseInt(document.getElementById('age-month').value, 10);
      const day = parseInt(document.getElementById('age-day').value, 10);
      const year = parseInt(document.getElementById('age-year').value, 10);

      if (!month || !day || !year) {
        return;
      }

      const age = calculateAge(year, month, day);

      if (age >= MIN_AGE) {
        setVerified();
        closeModal(modal);
        return;
      }

      window.location.href = 'https://www.google.com';
    });
  });
})();
